export const DYNAMIC_CHANNELS = new Map([
  ["ProKino", { id: 1_000_001, type: "free", staticChannelId: 1255 }],
  ["FilmUADrama", { id: 1_000_002, type: "free", staticChannelId: 102 }],
  ["Світло", { id: 1_000_003, type: "free", staticChannelId: 91 }],
  ["36,6 HD", { id: 1_000_004, type: "free", staticChannelId: 353 }],
  ["Кус КУС", { id: 1_000_005, type: "free", staticChannelId: 410 }],
  ["Дача", { id: 1_000_006, type: "free", staticChannelId: 83 }],
  ["XSPORT", { id: 1_000_007, type: "free", staticChannelId: 13 }],
  ["Xsport+", { id: 1_000_008, type: "free", staticChannelId: 1128 }],
  ["НАШЕ УЛЮБЛЕНЕ КІНО", { id: 1_000_009, type: "free", staticChannelId: 328 }],
  ["One Planet", { id: 1_000_010, type: "free", staticChannelId: 1221 }],
  [
    "Орел і решка Морський сезон",
    { id: 105, type: "free", staticChannelId: 1529 },
  ],
  ["Viasat Explore", { id: 104, type: "free", staticChannelId: 1637 }],
  ["Viasat Nature", { id: 103, type: "free", staticChannelId: 1639 }],
  ["Viasat History", { id: 102, type: "free", staticChannelId: 1638 }],
  ["Хіт Комедія", { id: 101, type: "free" }],
  ["Хіт Бойовик", { id: 100, type: "free" }],
  [
    "Classic Movies and Cartoons HD",
    { id: 99, type: "free", staticChannelId: 1519 },
  ],
  ["Де жити", { id: 98, type: "free" }],
  ["Кіно еротіка", { id: 97, type: "free", staticChannelId: 1499 }],
  ["Романтичний марафон", { id: 96, type: "free" }],
  ["Місія краса", { id: 95, type: "free" }],
  ["Врятуйте нашу сім`ю", { id: 94, type: "free" }],
  ["Ревізор", { id: 93, type: "free" }],
  ["Стосується кожного. Краще", { id: 91, type: "free" }],
  [
    "Орел і решка Морський сезон",
    { id: 90, type: "free", staticChannelId: 1529 },
  ],
  ["Dev test", { id: 89, type: "free" }],
  ["Один за всех HD", { id: 88, type: "free" }],
  ["Супермама", { id: 86, type: "free" }],
  ["Мелодрами", { id: 85, type: "free" }],
  ["Реаліті шоу", { id: 84, type: "free" }],
  ["Fun comedy", { id: 83, type: "free" }],
  ["Київ", { id: 82, type: "free", staticChannelId: 40 }],
  ["Слідство ведуть екстрасенси", { id: 81, type: "free" }],
  ["ICTV серіали", { id: 80, type: "free" }],
  ["Kyivstar test", { id: 79, type: "free" }],
  ["UA Travel", { id: 77, type: "free", staticChannelId: 1140 }],
  ["Загублений світ", { id: 76, type: "free" }],
  ["Одруження наосліп", { id: 75, type: "free" }],
  ["Сімейні мелодрами", { id: 74, type: "free" }],
  ["Гумор", { id: 73, type: "free" }],
  ["Панянка-селянка", { id: 72, type: "free" }],
  ["Опер за викликом", { id: 71, type: "free" }],
  ["Світ навиворіт", { id: 70, type: "free" }],
  ["ЖВЛ", { id: 69, type: "free" }],
  ["Kinosweet", { id: 68, type: "paid", staticChannelId: 1252 }],
  ["Bolt", { id: 67, type: "paid", staticChannelId: 267 }],
  ["Cinema legend hd", { id: 66, type: "paid", staticChannelId: 1296 }],
  ["Cinema prime hd", { id: 65, type: "paid", staticChannelId: 1295 }],
  ["Cinema kinohit hd", { id: 64, type: "paid", staticChannelId: 1294 }],
  ["StarFamily", { id: 63, type: "free" }],
  ["Стосується кожного", { id: 61, type: "free", staticChannelId: 1290 }],
  ["NLK", { id: 60, type: "free" }],
  ["Gagsnetwork", { id: 59, type: "free", staticChannelId: 1124 }],
  ["Espresso HD", { id: 58, type: "free", staticChannelId: 49 }],
  ["Inrating", { id: 57, type: "free" }],
  ["Готуємо разом", { id: 54, type: "free", staticChannelId: 1288 }],
  ["Travel and Food", { id: 53, type: "paid", staticChannelId: 350 }],
  ["Continent E", { id: 52, type: "paid", staticChannelId: 1212 }],
  ["Kinoliving", { id: 51, type: "paid", staticChannelId: 1217 }],
  ["Zoosweet", { id: 50, type: "free", staticChannelId: 1254 }],
  ["Орел і решка", { id: 49, type: "free", staticChannelId: 1275 }],
  ["Кіно та серіали", { id: 48, type: "free", staticChannelId: 1277 }],
  ["Вещдок", { id: 47, type: "free", staticChannelId: 1276 }],
  ["Кіноказка", { id: 46, type: "free", staticChannelId: 1127 }],
  ["Рибалка", { id: 45, type: "free", staticChannelId: 417 }],
  ["Dorama", { id: 44, type: "paid", staticChannelId: 327 }],
  ["Kinowood", { id: 43, type: "paid", staticChannelId: 1228 }],
  ["NOW series", { id: 42, type: "paid", staticChannelId: 1226 }],
  ["StarCinema", { id: 41, type: "paid", staticChannelId: 246 }],
  ["Cinema Family HD", { id: 38, type: "paid", staticChannelId: 1260 }],
  ["Cinema Comedy HD", { id: 37, type: "paid", staticChannelId: 1247 }],
  ["Cinema Action HD", { id: 36, type: "paid", staticChannelId: 1246 }],
  ["Cinema Megahit HD", { id: 35, type: "paid", staticChannelId: 1248 }],
  ["Cinema Fantasy HD", { id: 34, type: "paid", staticChannelId: 1245 }],
  ["Niki Junior", { id: 33, type: "paid", staticChannelId: 280 }],
  ["Niki kids", { id: 32, type: "paid", staticChannelId: 283 }],
  ["4ever Cinema", { id: 31, type: "paid", staticChannelId: 1187 }],
  ["4ever Theater", { id: 30, type: "paid", staticChannelId: 1218 }],
  ["4ever Drama", { id: 29, type: "paid", staticChannelId: 1219 }],
  ["VivaLatino", { id: 28, type: "paid", staticChannelId: 1223 }],
  ["Black", { id: 27, type: "paid", staticChannelId: 1188 }],
  ["4ever music", { id: 26, type: "paid", staticChannelId: 366 }],
  ["UA Music", { id: 25, type: "paid", staticChannelId: 1210 }],
  ["EU Music HD", { id: 20, type: "paid", staticChannelId: 48 }],
  ["Канал 24", { id: 19, type: "free" }],
  ["Ентер фільм", { id: 16, type: "free", staticChannelId: 50 }],
  ["К1", { id: 15, type: "free", staticChannelId: 42 }],
  ["Піксель", { id: 14, type: "free", staticChannelId: 27 }],
  ["Мега", { id: 12, type: "free", staticChannelId: 35 }],
  ["НТН", { id: 10, type: "free", staticChannelId: 29 }],
  ["Индиго ТВ", { id: 6, type: "free" }],
  ["ТРКУ", { id: 4, type: "free" }],
]);
